import React from 'react'
import { connect, useSelector } from 'react-redux'
import { BannerStatusTile, BannerTilesGroup, DetailTilesContainer, EnvironmentTitle, HeroPanel } from 'view/shared/heroPanel'
import { WindowActions } from 'epics/windowEpic'
import { Locale, Translation } from 'locale'
import { useAuthorisedUser, useUser } from 'view/hooks'
import { fatFingerLimitUserGetterSelector } from 'selectors/userSelectors'

type TradingFatFingerLimitsHeroPanelProps = DispatchProps

interface StateProps {}

interface DispatchProps {
  onTearout: () => void
}

const mapDispatchToProps = {
  onTearout: () => WindowActions.tearoutGrid('/quote/tearout/tradingFatFingerLimits')
}

const TradingFatFingerLimitsHeroPanelComponent: React.FunctionComponent<TradingFatFingerLimitsHeroPanelProps> = props => {
  const authorisedUser = useAuthorisedUser()
  const currentUser = useUser(authorisedUser.id)

  const userFatFingerLimits = useSelector(fatFingerLimitUserGetterSelector)(currentUser?.id || '')

  return (
    <HeroPanel onTearout={props.onTearout}>
      <DetailTilesContainer>
        <EnvironmentTitle data-test-id={'TradingFatFingerLimitsHeroPanel-EnvironmentTitle'}>
          {Locale.translate(Translation.TC_FAT_FINGER_LIMITS)}
        </EnvironmentTitle>
        <BannerTilesGroup title={Locale.translate(Translation.TC_HERO_SUMMARY)}>
          <BannerStatusTile title={Locale.translate(Translation.TC_TOTAL)} label={userFatFingerLimits.length} />
        </BannerTilesGroup>
      </DetailTilesContainer>
    </HeroPanel>
  )
}

export const TradingFatFingerLimitsHeroPanel = connect<StateProps, DispatchProps>(
  null,
  mapDispatchToProps
)(TradingFatFingerLimitsHeroPanelComponent)
